import { Form } from "reactstrap";
import * as auth from "./auth";

const Paho = window.Paho;
let client = null;
let isConnected = false;
let selected_topic = null;
const subscribers = {};



export function connect(clientId) {
    console.log("try to connect to mqtt");
    console.log(`use ssl: ${process.env.REACT_APP_USE_SSL}`);
    client = new Paho.MQTT.Client(process.env.REACT_APP_MQTT_HOST, parseInt(process.env.REACT_APP_MQTT_PORT), clientId);
    client.onConnectionLost = responseObject => {
        if (responseObject.errorCode !== 0) {
            console.log("onConnectionLost:" + responseObject.errorMessage);
        }
        let connected = false

       try{
           client.connect({
               onSuccess: () => {
                   console.log("MQTT connect successfully");
                   while(!connected && selected_topic != null){
                       try{
                           client.subscribe(selected_topic);
                           connected = true
                       }catch{
                           connected = false
                       }
                   }
                   isConnected = true;
               },
               onFailure: () => {
                   console.log("MQTT can not connect");
               },
               mqttVersion: 4,
               useSSL: process.env.REACT_APP_USE_SSL === "1" ? true : false,
               keepAliveInterval: 10,
           });
       }catch(e){
            console.log(e)
       }
        connected = false
    };
    client.onMessageArrived = message => {
        console.log(message);
        const body = message.payloadString;
        const topic = message.destinationName;
        const subscriber = subscribers[topic];
        subscriber && subscriber(body);
    };
    client.connect({
        onSuccess: () => {
            console.log("MQTT connect successfully");
            isConnected = true;
        },
        onFailure: () => {
            console.log("MQTT can not connect");
        },
        mqttVersion: 4,
        useSSL: process.env.REACT_APP_USE_SSL === "1" ? true : false,
        keepAliveInterval: 10,
    });
}

let tryToSubscribe = 0;
export function subscribe(topic, onReceiveMessage) {
    selected_topic = topic
    if (!isConnected) {
        if (tryToSubscribe < 15) {
            console.log("can not subscribe try again");
            setTimeout(() => {
                subscribe(topic, onReceiveMessage);
            }, 100);
        }
        tryToSubscribe++;
        return;
    }
    try{
        client.subscribe(topic, {qos: 2});
    }catch (e) {
        console.error(e)
    }

    subscribers[topic] = onReceiveMessage;
    return true
}

let tryToSendMessage = 0;
export function sendMessage(topic, body) {
    if (!isConnected) {
        if (tryToSendMessage < 15) {
            setTimeout(() => {
                sendMessage(topic, body);
            }, 100);
        }
        tryToSendMessage++;
        return;
    }
    const message = new Paho.MQTT.Message(body);
    message.destinationName = topic;
    message.qos = 2;
    if(isConnected){
        client.send(message);
        return true
    }
}
